import actionTypes from './actionTypes'
import makeUniqueId from 'helpers/makeUniqueId'

const quizActions = {
	initializeQuizCreate(quizUID) {
		return {
			type: actionTypes.QUIZ_INITIALIZE,
			quizUID,
		}
	},
	finalizeQuizCreate() {
		return {
			type: actionTypes.QUIZ_FINALIZE,
		}
	},
	duplicateQuestion(duplicateQuestionId) {
		return {
			type: actionTypes.QUIZ_DUPLICATE_QUESTION,
			questionId: makeUniqueId(),
			duplicateQuestionId,
		}
	},
	deleteQuestion(questionId, serverId) {
		return {
			type: actionTypes.QUIZ_DELETE_QUESTION,
			questionId,
			serverId,
		}
	},
	addAnswer(questionId) {
		return {
			type: actionTypes.QUIZ_ADD_ANSWER,
			questionId,
		}
	},
	addQuestion() {
		return {
			type: actionTypes.QUIZ_ADD_QUESTION,
			questionId: makeUniqueId(),
		}
	},
	dragQuestion(draggedQuestion, replacedQuestion) {
		return {
			type: actionTypes.QUIZ_DRAG_QUESTION,
			draggedQuestion,
			replacedQuestion,
		}
	},
	dropQuestion() {
		return {
			type: actionTypes.QUIZ_DROP_QUESTION,
		}
	},
	dragAnswer(draggedAnswer, replacedAnswer) {
		return {
			type: actionTypes.QUIZ_DRAG_ANSWER,
			draggedAnswer,
			replacedAnswer,
		}
	},
	dropAnswer(questionId) {
		return {
			type: actionTypes.QUIZ_DROP_ANSWER,
			questionId,
		}
	},
	toggleCollapseQuestion(questionId) {
		return {
			type: actionTypes.QUIZ_TOGGLE_COLLAPSE_QUESTION,
			questionId,
		}
	},
	collapseAll() {
		return {
			type: actionTypes.QUIZ_COLLAPSE_ALL,
		}
	},
	expandAll() {
		return {
			type: actionTypes.QUIZ_EXPAND_ALL,
		}
	},
	questionChange(value, questionId) {
		return {
			type: actionTypes.QUIZ_QUESTION_CHANGE,
			value,
			questionId,
		}
	},
	questionSave(questionId) {
		return {
			type: actionTypes.QUIZ_QUESTION_SAVE,
			questionId,
		}
	},
	questionToPlainText(questionId) {
		return {
			type: actionTypes.QUIZ_QUESTION_TO_PLAIN_TEXT,
			questionId,
		}
	},
	answerChange(value, questionId, answerId) {
		return {
			type: actionTypes.QUIZ_ANSWER_CHANGE,
			value,
			questionId,
			answerId,
		}
	},
	answerSave(questionId) {
		return {
			type: actionTypes.QUIZ_ANSWER_SAVE,
			questionId,
		}
	},
	titleChange(value) {
		return {
			type: actionTypes.QUIZ_TITLE_CHANGE,
			value,
		}
	},
	titleSave(value) {
		return {
			type: actionTypes.QUIZ_TITLE_SAVE,
			value,
		}
	},
	saveQuiz() {
		return {
			type: actionTypes.QUIZ_SAVE_QUIZ,
		}
	},
	cancelQuiz() {
		return {
			type: actionTypes.QUIZ_CANCEL_QUIZ,
		}
	},
	cancelConfirm() {
		return {
			type: actionTypes.QUIZ_CANCEL_QUIZ_CONFIRMED,
		}
	},
	cancelReject() {
		return {
			type: actionTypes.QUIZ_CANCEL_QUIZ_REJECTED,
		}
	},
	deleteAnswer(questionId, answerId) {
		return {
			type: actionTypes.QUIZ_DELETE_ANSWER,
			answerId,
			questionId,
		}
	},
	answerCheckboxChange(questionId, answerId) {
		return {
			type: actionTypes.QUIZ_ANSWER_CHECKBOX_CHANGE,
			answerId,
			questionId,
		}
	},
	questionFocus(questionId) {
		return {
			type: actionTypes.QUIZ_QUESTION_FOCUS,
			questionId,
		}
	},
	answerFocus(questionId, answerId) {
		return {
			type: actionTypes.QUIZ_ANSWER_FOCUS,
			answerId,
			questionId,
		}
	},
	helpButtonClick() {
		return {
			type: actionTypes.QUIZ_TOOLBAR_HELP_BUTTON_CLICK,
		}
	},
	addReferenceMediaClick(questionId) {
		return {
			type: actionTypes.QUIZ_ADD_REFERENCE_MEDIA_CLICK,
			questionId,
		}
	},
	referenceMediaMenuClick(mediaType, questionId) {
		return {
			type: actionTypes.QUIZ_REFERENCE_MEDIA_MENU_CLICK,
			mediaType,
			questionId,
		}
	},
	uploadReferenceMedia(allowedTypes, files, questionId, force) {
		return {
			type: actionTypes.QUIZ_UPLOAD_REFERENCE_MEDIA,
			allowedTypes,
			files,
			questionId,
			force,
		}
	},
	uploadReferenceMediaError(message, questionId) {
		return {
			type: actionTypes.QUIZ_UPLOAD_REFERENCE_MEDIA_ERROR,
			message,
			questionId,
		}
	},
	nearpodPickerCancel() {
		return {
			type: actionTypes.QUIZ_NEARPOD_PICKER_CANCEL,
		}
	},
	deleteReferenceMedia(questionId, iconId) {
		return {
			type: actionTypes.QUIZ_DELETE_REFERENCE_MEDIA,
			questionId,
			iconId,
		}
	},
	deleteReferenceMediaSuccess(questionId) {
		return {
			type: actionTypes.QUIZ_DELETE_REFERENCE_MEDIA_SUCCESS,
			questionId,
		}
	},
	requireUploadConfirmation(questionId) {
		return {
			type: actionTypes.QUIZ_UPLOAD_REQUIRE_CONFIRMATION,
			questionId,
		}
	},
	uploaderValidateSuccess(questionId, uploadId) {
		return {
			type: actionTypes.QUIZ_UPLOADER_VALIDATE_SUCCESS,
			questionId,
			uploadId,
		}
	},
	addTimer() {
		return {
			type: actionTypes.QUIZ_ADD_TIMER,
		}
	},
	editTimer() {
		return {
			type: actionTypes.QUIZ_EDIT_TIMER,
		}
	},
	deleteTimer() {
		return {
			type: actionTypes.QUIZ_DELETE_TIMER,
		}
	},
	saveTimer(value) {
		return {
			type: actionTypes.QUIZ_SAVE_TIMER,
			value,
		}
	},
	cancelTimer() {
		return {
			type: actionTypes.QUIZ_CANCEL_TIMER,
		}
	},
	questionUpdateError(questionId, error) {
		return {
			type: actionTypes.QUIZ_QUESTION_UPDATE_ERROR,
			questionId,
			error,
		}
	},
	saveQuizError(error) {
		return {
			type: actionTypes.QUIZ_SAVE_QUIZ_ERROR,
			error,
		}
	},
}

export default quizActions
